import React from 'react';
import { FizLink } from './svg/fizlink-logo';
import { FizlinkIcon } from './svg/fizlink-icon';

import './page-not-found.component.scss';

export const PageNotFound = () => {
    return (
        <div className="page-not-found">
            <div className="not-found-container">
                <FizlinkIcon height={96} />
                <h1>The page you're looking for doesn't exist.</h1>
                <a href="/home" className="return-home">Return home</a>
            </div>
            <footer className="footer-logo">
                <a href="/home">
                    <FizLink height={28} />
                </a>
            </footer>
        </div>
    );
};
